module.exports = __webpack_public_path__ + "img/21.c7c7f76b.jpg";